import React from 'react';
import {
    validatePackageCreateForm
} from '../../utils/validators/validateForm';
import {
    NotificationManager
} from 'react-notifications';
import * as actions from '../../actions';
import {
    connect
} from 'react-redux';
import {
    compose
} from 'redux';
import {
    withStyles
} from '@material-ui/core/styles';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import {
    FormattedMessage,
    injectIntl
} from 'react-intl';
import {
    MenuItem,
    Button,
    Card,
    CircularProgress,
    TextField
} from '@material-ui/core';

const styles = {
    width: '100%',
    height: '100%',
    formControl: {
        minWidth: '100%',
        margin: '0'
    }
};
class ServicePackageUpdate extends React.Component {
    constructor(props) {
        super();
        this.state = {
            name: props.data ? props.data.name : '',
            nameError: '',
            costPrice: props.data ? props.data.costPrice : '',
            costPriceError: '',
            price: props.data ? props.data.price : '',
            priceError: '',
            description: props.data ? props.data.description : '',
            descriptionError: '',
            loaderButton: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            validate: true,
            serviceId: props.data ? props.data.provider_service_id : '',
            packageId: props.data ? props.data.key : ''
        };
    }

    submit = async () => {
        const {
            name,
            costPrice,
            price,
            description
        } = this.state;
        const result = await validatePackageCreateForm({
                name,
                costPrice,
                price,
                description
            },
            this.handleError
        );

        if (result) {
            this.updatePackage();
        } else {
            NotificationManager.error( <
                FormattedMessage id = "Validation Error"
                defaultMessage = "Validation Error" /
                >
                ,
                'Error'
            );
        }
    };

    updatePackage = () => {
        this.setState({
            loader: true
        });
        const {
            name,
            costPrice,
            price,
            description,
            packageId
        } = this.state;
        this.props.updateServicePackageAction({
                name,
                costPrice,
                price,
                description,
                packageId: this.props.data.key
            },
            this.onAddDone
        );
    };
    handleError = params => {
        this.setState(params);
    };

    onAddDone = (success, data) => {
        this.setState({
            loader: false
        });
        if (success) {
            NotificationManager.success(data.message, 'Success');
            this.props.history.push({
                pathname: `/provider/service/package`,
                serviceId: this.state.serviceId
            });
        }
    };
    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress / > ;
        }
        return ( < Button variant = "raised"
            color = "primary"
            className = "jr-btn"
            onClick = {
                this.submit
            } >
            <
            FormattedMessage id = "update"
            defaultMessage = "Update" / >
            <
            /Button>
        );
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    render() {
        const {
            name,
            nameError,
            costPrice,
            costPriceError,
            price,
            priceError,
            description,
            descriptionError
        } = this.state;
        const {
            classes
        } = this.props;

        return ( < div className = "db-list-com " > < div className = "hom-cre-acc-left hom-cre-acc-right" >
            <
            form className = "form-new"
            noValidate autoComplete = "off"
            id = "package-update" >
            <
            div className = "row" >
            <
            div className = "col-md-6 col-xs-12" >
            <
            TextField type = "text"
            error = {
                nameError ? true : false
            }
            helperText = {
                nameError
            }
            name = "name"
            label = {
                this.props.intl.formatMessage({
                    id: 'name'
                })
            }
            id = "name"
            fullWidth placeholder = {
                this.props.intl.formatMessage({
                    id: 'name'
                })
            }
            className = "login-form-textfield "
            defaultValue = {
                name
            }
            margin = "normal"
            onChange = {
                this.handleChange('name')
            }
            /> </div >
            <
            div className = "col-md-6 col-xs-12" >
            <
            TextField type = "text"
            error = {
                costPriceError ? true : false
            }
            helperText = {
                costPriceError
            }
            name = "costPrice"
            label = {
                this.props.intl.formatMessage({
                    id: 'costPrice'
                })
            }
            id = "costPrice"
            fullWidth placeholder = {
                this.props.intl.formatMessage({
                    id: 'costPrice'
                })
            }
            className = "login-form-textfield "
            defaultValue = {
                costPrice
            }
            margin = "normal"
            onChange = {
                this.handleChange('costPrice')
            }
            /> </div >
            <
            div className = "col-md-6 col-xs-12" >
            <
            TextField type = "text"
            error = {
                priceError ? true : false
            }
            helperText = {
                priceError
            }
            name = "price"
            label = {
                this.props.intl.formatMessage({
                    id: 'sellingPrice'
                })
            }
            id = "price"
            fullWidth placeholder = {
                this.props.intl.formatMessage({
                    id: 'sellingPrice'
                })
            }
            className = "login-form-textfield "
            defaultValue = {
                price
            }
            margin = "normal"
            onChange = {
                this.handleChange('price')
            }
            /> </div >
            <
            div className = "col-md-12 col-xs-12" >
            <
            TextField type = "text"
            error = {
                descriptionError ? true : false
            }
            helperText = {
                descriptionError
            }
            name = "description"
            label = {
                this.props.intl.formatMessage({
                    id: 'description'
                })
            }
            id = "description"
            fullWidth placeholder = {
                this.props.intl.formatMessage({
                    id: 'description'
                })
            }
            className = "login-form-textfield "
            defaultValue = {
                description
            }
            margin = "normal"
            onChange = {
                this.handleChange('description')
            }
            /> </div >
            <
            div className = "col-md-12 col-xs-12 mt-3" > {
                this.renderButton()
            } < /div> </div > < /form> </div > < /div>
        );
    }
}

const composedComponent = compose(
    withStyles(styles),
    connect(
        null,
        actions
    )
);
export default withCustomTheme(
    composedComponent(injectIntl(ServicePackageUpdate))
);


// WEBPACK FOOTER //
// ./src/components/Providers/ServicePackageUpdate.js